<script>
import layout from '@src/mixins/layout.vue'

export default {
  mixins: [layout],
  data() {
    return {
      org: null,
    }
  },
  computed: {
    logoComputed() {
      return this.$style.logoContainer
    },
    menuItems() {
      return [
        {
          icon: 'settings',
          name: this.$t('user-menu.settings'),
          route: 'settings.profile',
        },
        {
          icon: 'logout',
          name: this.$t('user-menu.logout'),
          route: 'safeHavenLogout',
        },
      ]
    },
  },
  mounted() {
    this.org = JSON.parse(localStorage.getItem('organisationDetails'))
  },
  methods: {},
}
</script>

<template>
  <v-app-bar
    :height="$vuetify.breakpoint.mdAndUp ? 76 : 55"
    color="white"
    clipped-left
    expand-on-hovers
    clipped
    elevate-on-scroll
    clipped-right
    elevation="1"
    app
  >
    <div class="d-flex flex-grow-1 align-center" :class="$style.mobilemenu">
      <div :class="logoComputed">
        <router-link :to="{ name: 'safehaven-dashboard' }">
          <v-img
            v-if="org"
            :height="$vuetify.breakpoint.mdAndUp ? 54 : 45"
            contain
            :class="[
              $style.logoImg,
              org.org_short_name === 'healthbook' ? 'healthbook' : 'safehaven',
            ]"
            :src="org.logo_url"
          ></v-img>
        </router-link>
      </div>
    </div>
  </v-app-bar>
</template>

<style lang="scss" module scoped>
@import '@design';

.logoContainer {
  width: 223px;
  max-width: 223px;
  height: 100%;
}

.healthbookLogoContainer {
  width: 340px !important;
  height: 100%;
}

.logoImg {
  background-position: left center;
}

.listItem {
  height: 35px;
  min-height: 0 !important;
  padding: 0 !important;
}
.actionBtn {
  justify-content: flex-start !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  letter-spacing: 0.25px;
}

@media screen and (max-width: 960px) {
  .logoContainer {
    width: 185px;
    max-width: 185px;
  }
}
@media screen and (max-width: 599px) {
  .mobilemenu {
    justify-content: center !important;
  }
  .mobilehide {
    display: none !important;
  }
}
@media screen and (max-width: 370px) {
  .logoContainer {
    width: 20px;
    max-width: 200px;
  }
}
@media screen and (max-width: 310px) {
  .logoContainer {
    width: 10px;
    max-width: 130px;
  }
}
</style>

<style scoped>
@media screen and (max-width: 400px) {
  /deep/ .px-5.mobilespaceclss {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .spacer {
    display: none !important;
  }
}
@media screen and (max-width: 370px) {
  /deep/ .v-toolbar__content {
    padding: 4px 8px !important;
  }
  /deep/.safehaven .v-image__image--cover {
    background-size: contain !important;
  }
}
@media screen and (max-width: 365px) {
  /deep/ .px-5.mobilespaceclss {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}
@media screen and (max-width: 330px) {
  /deep/ .v-toolbar__content,
  .v-toolbar__extension {
    padding: 4px 4px;
  }
}
</style>
